// The commit this bundle was built from, and what counts as one (INT-7).
//
// A leaf module, so both the build watch (build.svelte.ts) and the till's
// store bridge (till/shell.ts) read it without importing each other.

/**
 * The commit this bundle was built from: `git rev-parse HEAD` when Vite built
 * or served it (build-marker.js), so the dev server names one too. Empty
 * outside Vite.
 */
export const BUNDLE_COMMIT: string = typeof __BUILD_COMMIT__ === 'string' ? __BUILD_COMMIT__ : '';

// A full commit hash: SHA-1, or SHA-256 in a repository that uses it.
// web/build-marker.js holds the same pattern for the build itself.
const COMMIT = /^[0-9a-f]{40}([0-9a-f]{24})?$/;

/** Whether `value` is a full commit hash. */
export function isCommit(value: string): boolean {
	return COMMIT.test(value);
}
